module.exports = __webpack_public_path__ + "img/home-background-v2.f10705d1.svg";